module.exports = __webpack_public_path__ + "01_short_brown.d40cf7c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/01_short_brown.png
// module id = HG9A
// module chunks = 0